<app-floorplan-ex-zone-menu></app-floorplan-ex-zone-menu>
<hr />
<app-floorplan-dust-ex-zone-menu></app-floorplan-dust-ex-zone-menu>
<hr />
<app-floorplan-danger-area-menu></app-floorplan-danger-area-menu>
<hr />
<app-floorplan-wildcard-zone-menu></app-floorplan-wildcard-zone-menu>
